export default __webpack_public_path__ + "static/wfh-bd9c99448a4ee8cac4eddc5061555f20.jpg";